import { Alert as MuiAlert, AlertProps } from '@mui/material';
import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const Alert: React.FC<AlertProps> = ({ ...props }) => {
  return (
    <MuiAlert
      iconMapping={{
        success: <InfoOutlinedIcon fontSize="inherit" />,
        error: <InfoOutlinedIcon fontSize="inherit" />,
        warning: <InfoOutlinedIcon fontSize="inherit" />,
      }}
      style={{ alignItems: 'flex-start' }}
      {...props}
    />
  );
};
